import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { getPortfolioNewsCompanies } from 'src/app/home/adapters'
import { portfolioNewsKeys } from 'src/app/home/queries/keys'

export interface IUsePortfolioNewsCompaniesQueryParams {
  enabled: boolean
}

export const usePortfolioNewsCompaniesQuery = (
  params: IUsePortfolioNewsCompaniesQueryParams,
): UseQueryResult<string[], Error> => {
  return useQuery({
    queryKey: portfolioNewsKeys.companies(),
    queryFn: async (): Promise<string[]> => {
      const response = await getPortfolioNewsCompanies()
      return response.companies
    },
    enabled: params.enabled,
    staleTime: 5 * 60 * 1000,
  })
}
